'use client';

import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import PublicTopbar from '@/components/PublicTopbar';
import OrderWizardContent from './components/OrderWizardContent';
import { useAuth } from '@/contexts/AuthContext';

export default function OrderWizardPage() {
  const { user, loading, refreshSession } = useAuth();
  const router = useRouter();
  const [authChecked, setAuthChecked] = useState(false);
  const isVerifiedUser = (candidate: any) => Boolean(candidate?.email_confirmed_at || candidate?.confirmed_at);
  const verifyEmailPath = (email?: string) =>
    `/verify-email${email ? `?email=${encodeURIComponent(email)}` : ''}`;

  useEffect(() => {
    let cancelled = false;
    const ensureAuth = async () => {
      if (loading) return;

      if (user) {
        if (!isVerifiedUser(user)) {
          router.replace(verifyEmailPath(user.email));
          return;
        }
        if (!cancelled) setAuthChecked(true);
        return;
      }

      const refreshedUser = await refreshSession();
      if (cancelled) return;
      if (!refreshedUser) {
        router.replace('/sign-up-login');
        return;
      }
      if (!isVerifiedUser(refreshedUser)) {
        router.replace(verifyEmailPath(refreshedUser.email));
        return;
      }
      setAuthChecked(true);
    };

    ensureAuth();
    return () => {
      cancelled = true;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, user]);

  if (loading || !authChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-brand-500/30 border-t-brand-400 rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-navy-900 grid-texture">
      <PublicTopbar />
      <main className="pt-16">
        <OrderWizardContent />
      </main>
    </div>
  );
}